import * as React from 'react'
import styled from 'styled-components'
import ListItem, {ListItemProps} from '@mui/material/ListItem'
import ListItemAvatar from '@mui/material/ListItemAvatar'
import Avatar from '@mui/material/Avatar'
import Divider from '@mui/material/Divider'
import SvgIconAtom from '../svg_icon/svg_icon.atom'
import ProductListItemStyles from './productlist_item.styles'
import TypographyAtom from '../typography/typography.atom'
import StackAtom from '../../to_layout/stack/stack.atom'
import PackageJpg from '../../../assets/images/package.jpg'

interface ApProductListItemProps extends ListItemProps {
  ap_type: 'productImage' | 'productImageNull' | 'packageIcon'
  ap_product_image?: string
  ap_product_name?: string
  ap_product_quantity?: string
  ap_product_services?: string[]
}

const ProductListItemAtom = styled((props: ApProductListItemProps) => {
  const {ap_product_name, ap_product_quantity, ap_product_services} = props
  // if product image loads success
  const successHandler = (
    evt: React.SyntheticEvent<HTMLImageElement, Event>,
  ) => {
    if (evt.currentTarget.className !== 'error') {
      evt.currentTarget.className = 'success'
    }
  }

  // if product image fails to load
  const errorHandler = (evt: React.SyntheticEvent<HTMLImageElement, Event>) => {
    evt.currentTarget.src = `${PackageJpg}`
    evt.currentTarget.className = 'error'
  }

  return (
    <ListItem {...props}>
      {props.ap_type === 'productImage' && (
        <>
          <StackAtom ap_type="row" className="product-avatar">
            <ListItemAvatar>
              <Avatar variant="square">
                <img
                  src={props.ap_product_image}
                  onLoad={successHandler}
                  onError={errorHandler}
                  alt="Product"
                />
              </Avatar>
            </ListItemAvatar>
          </StackAtom>
          <StackAtom ap_type="column" className="product-title">
            <TypographyAtom ahd_type="product">
              {ap_product_name || 'Product'}
            </TypographyAtom>
            <Divider />
            <TypographyAtom ahd_type="regText">
              <div className="product-details-wrapper">
                <div className="product-quantity-wrapper">
                  {ap_product_quantity || 'regText'}
                </div>

                {ap_product_services?.map((each: string) => {
                  return (
                    <div key={`${each}`} className="service-string-wrapper">
                      {each}
                    </div>
                  )
                })}
              </div>
            </TypographyAtom>
          </StackAtom>
        </>
      )}
      {props.ap_type === 'productImageNull' && (
        <StackAtom ap_type="column" className="product-title">
          <TypographyAtom ahd_type="product">
            {ap_product_name || 'Product'}
          </TypographyAtom>
          <Divider />
          <TypographyAtom ahd_type="regText">
            {ap_product_quantity || 'regText'}
          </TypographyAtom>
        </StackAtom>
      )}
      {props.ap_type === 'packageIcon' && (
        <>
          <StackAtom ap_type="row" className="product-avatar">
            <ListItemAvatar>
              <Avatar variant="square">
                <SvgIconAtom ap_type="package" />
              </Avatar>
            </ListItemAvatar>
          </StackAtom>
          <StackAtom ap_type="column" className="product-title">
            <TypographyAtom ahd_type="product">
              {ap_product_name || 'Product'}
            </TypographyAtom>
            <Divider />
            <TypographyAtom ahd_type="regText">
              {ap_product_quantity || 'regText'}
            </TypographyAtom>
          </StackAtom>
        </>
      )}
    </ListItem>
  )
})`
  ${ProductListItemStyles}
`

export default ProductListItemAtom
